<template>
  <span v-if="value" :class="status">
    {{ message }}
  </span>
</template>

<script>
export default {
  name: 'response-message',
  props: {
    value: Object
  },
  data () {
    return {
      message: null,
      status: null,
    }
  },
  watch: {
    value: function(newVal) {
      if(newVal.error === '200 OK'){
        this.$root.$bvToast.toast('登録しました！', {
          autoHideDelay: 3000,
          appendToast: true,
          variant: 'success',
          toaster: 'b-toaster-bottom-right',
        })
        this.message = 'OK！'
        this.status = 'success'
      }else if(newVal.error.startsWith('503')){ //TODO 応急対応
        this.$root.$bvToast.toast('現在メンテナンス中です！', {
          autoHideDelay: 5000,
          appendToast: true,
          toaster: 'b-toaster-bottom-right',
        })
        this.$router.push({ path: '/' })
      }else{
        this.$root.$bvToast.toast(newVal.msg || newVal.error, {
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'danger',
          toaster: 'b-toaster-bottom-right',
        })
        this.message = newVal.msg || newVal.error
        this.status = 'fail'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  margin: 5px;
}
.success {
  color: #0F0;
}
.fail {
  color: #F00;
}
</style>